<template lang="pug">
    .guest-layout
        .guest-layout__left
            .guest-layout__left-img
                .guest-layout__left-img-overlay
            guest-footer-control
        .guest-layout__right
            router-link.guest-layout__right-logo(:to="{ name: 'login-page' }")
                img(src="/images/client/got-me-hookd/logo.png" alt="")
            slot
            .guest-layout__right-footer
                guest-footer-control
</template>

<script>
export default {
    name: 'guest-layout',
}
</script>
